import { Button } from 'components';
import React from 'react';
import styled from 'styled-components';
import theme from 'themes';
const FooterBtnContainer = styled.div`
  display: flex;
  margin-top: auto;
  padding: 16px 20px;
  gap: 0.75rem;
  justify-content: end;
  border-top: 1px solid ${theme.colors.lightGrey10};
  background: ${theme.colors.white};
  box-shadow: 0px 12px 24px 12px rgba(0, 0, 0, 0.05);
`;
type Props = {
  leftBtn?: string | JSX.Element;
  rightBtn?: string | JSX.Element;
  handleFlyoutClose?: () => void;
  handleRightBtnClick?: () => void;
  disable?: boolean;
};
const FlyoutFooter = ({
  leftBtn,
  rightBtn,
  handleFlyoutClose,
  handleRightBtnClick,
  disable
}: Props): JSX.Element => {
  return (
    <FooterBtnContainer>
      {leftBtn && (
        <Button variant="outline-blue" onClick={handleFlyoutClose} width="107px" size="small">
          {leftBtn}
        </Button>
      )}
      <Button
        variant="filled-primary"
        width="114px"
        onClick={handleRightBtnClick}
        size="small"
        disabled={disable}
      >
        {rightBtn}
      </Button>
    </FooterBtnContainer>
  );
};

export default FlyoutFooter;
